import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button data-testid="theme-toggle" onClick={toggle} aria-label="Toggle theme"
      className={`w-10 h-10 rounded-full flex items-center justify-center border border-maroon/15 bg-white text-maroon hover:border-gold transition-colors ${className}`}>
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
